// react
import { useState } from 'react';

// types
import { Entity } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddUser } from '../../forms/FormAddUser/FormAddUser';

// props
export interface DialogAddUserProps {
	entity?: Entity;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddUser = ({ entity, isOpen, onClose, onSuccess }: DialogAddUserProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addUser'),
					form: 'form-add-user',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={580}
			onClose={onClose}
			title={{
				children: t('addUser'),
				variant: 'h3',
			}}>
			<FormAddUser
				entity={entity}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
